import createIcon from '../../createIcon';

/**
 * @component @name FormatListBulleted
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4yNSAxMC41QzMuNDIgMTAuNSAyLjc1IDExLjE3IDIuNzUgMTJDMi43NSAxMi44MyAzLjQyIDEzLjUgNC4yNSAxMy41QzUuMDggMTMuNSA1Ljc1IDEyLjgzIDUuNzUgMTJDNS43NSAxMS4xNyA1LjA4IDEwLjUgNC4yNSAxMC41Wk00LjI1IDQuNUMzLjQyIDQuNSAyLjc1IDUuMTcgMi43NSA2QzIuNzUgNi44MyAzLjQyIDcuNSA0LjI1IDcuNUM1LjA4IDcuNSA1Ljc1IDYuODMgNS43NSA2QzUuNzUgNS4xNyA1LjA4IDQuNSA0LjI1IDQuNVpNNC4yNSAxNi41QzMuNDIgMTYuNSAyLjc1IDE3LjE4IDIuNzUgMThDMi43NSAxOC44MiAzLjQzIDE5LjUgNC4yNSAxOS41QzUuMDcgMTkuNSA1Ljc1IDE4LjgyIDUuNzUgMThDNS43NSAxNy4xOCA1LjA4IDE2LjUgNC4yNSAxNi41Wk03LjI1IDE5SDIxLjI1VjE3SDcuMjVWMTlaTTcuMjUgMTNIMjEuMjVWMTFINy4yNVYxM1pNNy4yNSA1VjdIMjEuMjVWNUg3LjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatListBulleted = createIcon('FormatListBulleted', [
  [
    'path',
    {
      d: 'M4.25 10.5C3.42 10.5 2.75 11.17 2.75 12C2.75 12.83 3.42 13.5 4.25 13.5C5.08 13.5 5.75 12.83 5.75 12C5.75 11.17 5.08 10.5 4.25 10.5ZM4.25 4.5C3.42 4.5 2.75 5.17 2.75 6C2.75 6.83 3.42 7.5 4.25 7.5C5.08 7.5 5.75 6.83 5.75 6C5.75 5.17 5.08 4.5 4.25 4.5ZM4.25 16.5C3.42 16.5 2.75 17.18 2.75 18C2.75 18.82 3.43 19.5 4.25 19.5C5.07 19.5 5.75 18.82 5.75 18C5.75 17.18 5.08 16.5 4.25 16.5ZM7.25 19H21.25V17H7.25V19ZM7.25 13H21.25V11H7.25V13ZM7.25 5V7H21.25V5H7.25Z',
      key: '1p1tzh',
    },
  ],
]);

export default FormatListBulleted;
